import { useState, useEffect } from "react";
import API from "@/lib/api";
import { FileText, Package, DollarSign, Users, TrendingUp, Clock } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    API.get("/admin/stats").then((r) => setStats(r.data)).catch(console.error);
  }, []);

  if (!stats) return <div className="p-8 text-sm text-[#94A3B8]">Cargando dashboard...</div>;

  const cards = [
    { icon: FileText, label: "Cotizaciones Hoy", value: stats.quotes_today, accent: "#0047AB" },
    { icon: Clock, label: "Pendientes", value: stats.pending_quotes, accent: "#F59E0B" },
    { icon: Package, label: "En Producción", value: stats.orders_production, accent: "#E30613" },
    { icon: TrendingUp, label: "Listos / Entregados", value: `${stats.orders_ready} / ${stats.orders_delivered}`, accent: "#10B981" },
    { icon: DollarSign, label: "Ingresos Estimados", value: `Q${stats.estimated_revenue.toLocaleString()}`, accent: "#0047AB" },
    { icon: Users, label: "Clientes Totales", value: stats.total_clients, accent: "#475569" },
  ];

  return (
    <div className="p-6" data-testid="admin-dashboard">
      <div className="mb-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#0047AB] mb-2">Panel de Administración</p>
        <h1 className="text-2xl font-bold tracking-tight text-[#0F172A]" style={{ fontFamily: 'Chivo' }}>Dashboard</h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {cards.map((c, i) => (
          <div key={i} className="bg-white border border-[#E2E8F0] rounded-sm p-5" data-testid={`stat-card-${i}`}>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-8 rounded-sm flex items-center justify-center" style={{ backgroundColor: c.accent + "15" }}>
                <c.icon className="w-4 h-4" style={{ color: c.accent }} />
              </div>
              <span className="text-xs font-medium text-[#475569]">{c.label}</span>
            </div>
            <p className="text-2xl font-bold text-[#0F172A]">{c.value}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {/* Quick stats */}
        <div className="bg-white border border-[#E2E8F0] rounded-sm p-5">
          <h3 className="text-sm font-bold text-[#0F172A] mb-4" style={{ fontFamily: 'Chivo' }}>Resumen de Cotizaciones</h3>
          <div className="space-y-3">
            <StatRow label="Esta semana" value={stats.quotes_week} />
            <StatRow label="Este mes" value={stats.quotes_month} />
            <StatRow label="Total" value={stats.total_quotes} />
            <StatRow label="Pedidos totales" value={stats.total_orders} />
          </div>
        </div>

        {/* Top Products */}
        <div className="bg-white border border-[#E2E8F0] rounded-sm p-5">
          <h3 className="text-sm font-bold text-[#0F172A] mb-4" style={{ fontFamily: 'Chivo' }}>Productos Más Cotizados</h3>
          {stats.top_products.length === 0 ? (
            <p className="text-sm text-[#94A3B8]">Sin datos aún</p>
          ) : (
            <div className="space-y-3">
              {stats.top_products.map((p, i) => (
                <div key={i} className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-xs font-bold text-[#94A3B8] w-5">{i + 1}.</span>
                    <span className="text-sm text-[#0F172A]">{p.name}</span>
                  </div>
                  <span className="text-sm font-semibold text-[#0047AB]">{p.count} pzas</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function StatRow({ label, value }) {
  return (
    <div className="flex items-center justify-between text-sm">
      <span className="text-[#475569]">{label}</span>
      <span className="font-semibold text-[#0F172A]">{value}</span>
    </div>
  );
}
